import type {CardProps} from '@mui/material'
import {Card, IconButton, Stack} from '@mui/material'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import type {ForwardedRef, ReactElement} from 'react'
import {forwardRef} from 'react'

interface BasicCardProps extends CardProps {
  collapsed?: boolean
  onToggleCollapsed?: () => void
  showCollapseToggle?: boolean
  collapsedWidth?: number | string
  expandedWidth?: number | string
}

const BasicCard = forwardRef<HTMLDivElement, BasicCardProps>(function BasicCard(
  {
    children,
    id,
    collapsed = false,
    onToggleCollapsed,
    showCollapseToggle = false,
    collapsedWidth = 40,
    expandedWidth = 280,
    ...rest
  },
  ref: ForwardedRef<HTMLDivElement>,
): ReactElement {
  return (
    <Card
      ref={ref} // ✅ Attach the forwarded ref
      data-testid="mbai-main-basic-card"
      id={id || undefined}
      {...rest}
      sx={{
        width: showCollapseToggle ? (collapsed ? collapsedWidth : expandedWidth) : '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        ...rest.sx,
      }}
    >
      {!collapsed ? children : null}
      {showCollapseToggle && (
        <Stack
          direction="row"
          justifyContent={collapsed ? 'center' : 'flex-end'}
          alignItems="flex-end"
          py={1}
          mt="auto"
          flexShrink={0}
        >
          <IconButton
            size="small"
            onClick={onToggleCollapsed}
            sx={{marginRight: collapsed ? 0 : 0.8}}
            aria-label={collapsed ? 'Expand' : 'Collapse'}
          >
            {collapsed ? <KeyboardDoubleArrowRightIcon /> : <KeyboardDoubleArrowLeftIcon />}
          </IconButton>
        </Stack>
      )}
    </Card>
  )
})

export default BasicCard
